import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'zop-label',
    imports: [CommonModule],
    template: `
    <div class="formly-label">
      <label>{{ to.label }}</label>
      <small *ngIf="to.description" class="text-muted">{{ to.description }}</small>
    </div>
  `,
    styles: [`
    .formly-label {
      margin: 10px 0;
    }
    label {
      font-weight: bold;
    }
    .text-muted {
      display: block;
      font-size: 0.9em;
    }
  `]
})
export class LabelComponent extends FieldType<FieldTypeConfig> {}
